import FJActionConstant from "../../constant/FJActionConstant";
import FJViewConstant from "../../constant/FJViewConstant";

const initState = {
  volume: 0.5,
	mediaStatus: FJViewConstant.MEDIA_STATUS_SUCCESS,
	mediaName: '',
  fadeIn: 0,
  fadeOut: 2.5,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_AUDIO_VOLUME:
      return {
        ...state,
        volume: action.volume,
      };
    case FJActionConstant.SET_AUDIO_FADE_IN:
      return {
        ...state,
        fadeIn: action.fadeIn,
      };
    case FJActionConstant.SET_AUDIO_FADE_OUT:
      return {
        ...state,
        fadeOut: action.fadeOut,
      };
		case FJActionConstant.SET_AUDIO_MEDIA_NAME:
			return {
				...state,
				mediaName: action.mediaName
			}
    case FJActionConstant.SET_AUDIO_MEDIA_STATUS:
      return {
        ...state,
        mediaStatus: action.mediaStatus,
      }
    default:
      return state;
  }
}
